import { IReportTuyenSinhRequest } from "../../model/request/report/IReportTuyenSinhRequest";
import { apiClient } from "../apiClient";
export const REPORT_TUYENSINH_ENDPOINT = "report-tuyen-sinh";

export const reportTuyenSinhApi = {
  SelectByPaging: (request: IReportTuyenSinhRequest) =>
    apiClient.post(`${REPORT_TUYENSINH_ENDPOINT}/tong-hop`, request),
};
